import styled from 'styled-components';
import { HeaderMenuLateralProps } from '.';

export const Container = styled.div<HeaderMenuLateralProps>`
  display: flex;
  flex-direction: column;

  background-color: ${({ theme, $color, $variant }) => {
    if ($color === 'neutral') return theme.panel[$variant];
    if ($variant === 'translucent') return theme.panel[`${$variant}_2`];
    return theme.colors[$color][$color][2];
  }};

  padding: ${({ theme }) => theme.spacing[5]}px;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;

export const Botoes = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  gap: ${({ theme }) => theme.spacing[4]}px;
`;
